import { jwtDecode, type JwtPayload } from 'jwt-decode';
import Cookies from 'js-cookie';

export function decodeJwt<T>(token?: string) {
    try {
        if (!token) {
            /* HCP-700 removing the custom error to make sure it does not show up on sentry logs */
            return null;
        }

        const decodedJwt = jwtDecode(token);
        if (decodedJwt) {
            return {
                payload:
                    typeof decodedJwt === 'string'
                        ? decodedJwt
                        : (decodedJwt as JwtPayload & T),
            };
        }

        return null;
    } catch (e) {
        console.error('error decoding JWT:', e);
        return null;
    }
}

export function decodeJwtCookie<T>(cookieName?: string) {
    'use client';

    if (!cookieName) {
        return undefined;
    }

    const payload = decodeJwt<T>(Cookies.get(cookieName))?.payload;

    return payload && typeof payload !== 'string' ? payload : undefined;
}
